interface FetchOptions {
    [key: string]: any;
}

interface Params {
    [key: string]: any;
}

type InterceptorFn = (data: FetchOptions) => FetchOptions;

const interceptors: Set<InterceptorFn> = new Set();
const origin = window.location.origin;

export function appFetch<T>(
    url: string,
    params: Params | null,
    options: FetchOptions = {},
): Promise<T> {
    let urlSearchParams: URLSearchParams;
    const isGet = !options.method || options.method.toLowerCase() === 'get';

    if (isGet && params) {
        urlSearchParams = new URLSearchParams(params as Params);

        url = `${url}?${urlSearchParams.toString()}`;
        params = null;
    }

    const extendedOptions = {
        method: 'GET', // *GET, POST, PUT, DELETE, etc.
        // mode: 'cors', // no-cors, cors, *same-origin
        cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
        // credentials: 'same-origin', // include, *same-origin, omit
        headers: {
            'Content-Type': 'application/json',
            Origin: origin,
            // 'Content-Type': 'application/x-www-form-urlencoded',
        },
        redirect: 'follow', // manual, *follow, error
        referrer: 'no-referrer', // no-referrer, *client
        ...(!isGet && {
            body: params ? JSON.stringify(params) : undefined,
        }), // body data type must match "Content-Type" header,
        ...options,
    };

    const interceptedOptions = Array.from(interceptors).reduce(
        (acc, interceptor) => {
            return {
                ...acc,
                ...(interceptor(acc) || {}),
            };
        },
        extendedOptions,
    );

    return new Promise(async (resolve, reject) => {
        // @ts-ignore
        const response = await window.fetch(url, interceptedOptions);

        try {
            const data = await response.json();

            if (data.error) reject(data as GenericApiError<T>);
            else resolve(data);
        } catch (e) {
            reject(e);
        }
    });
}

export const registerInterceptor = (fn: InterceptorFn) => interceptors.add(fn);

export interface GenericApiError<T> {
    error: boolean;
    code: number;
    message?: string;
    messages: Array<validationError<T>>;
}

export interface validationError<T> {
    name: keyof T;
    error: {
        message: 'string';
        type: 'string';
    };
}

export type GenericApiResponse<T> = T | GenericApiError<T>;
